import React from "react";
import TestMappingRead from "components/Tests/TestMapping.jsx";

class TestMapping extends React.Component {
    render() {
        return (
            <TestMappingRead id={this.props}/>
        );
    }
}

export default (TestMapping);



// WEBPACK FOOTER //
// ./src/views/Tests/testMapping.jsx